import { formatDecimal } from "../components/charts/format";
import { NO_COMPARISON, variation } from "./analyticsDeltas";

// Os onze intervalos que a pagina mostra (D10 do plano da latencia do backend (`docs/superpowers/plans/2026-10-19-rpaa-286-latencia-fina.md`)). O backend guarda o histograma em passos de 100 ms ate aos
// 10 s, de 1 s ate aos 60 s, e um passo aberto a partir dos 60 000: cada chave e o inicio do seu passo.
// Cada inicio daqui tem de cair num passo guardado (o teste prende-o), e assim mudar a lista nunca mexe
// nos dados: so se somam passos de outra maneira.
export const LATENCY_INTERVALS = [0, 1000, 2000, 4000, 8000, 10000, 15000, 20000, 30000, 40000, 50000];
const OPEN_STEP = 60000;

const seconds = (ms) => String(ms / 1000);

const intervalLabel = (index, translate) => {
  const from = LATENCY_INTERVALS[index];
  const to = LATENCY_INTERVALS[index + 1];
  if (index === 0) return translate("analyticsLatencyUnder", { to: seconds(to) });
  if (to === undefined) return translate("analyticsLatencyOver", { from: seconds(from) });
  return translate("analyticsLatencyRange", { from: seconds(from), to: seconds(to) });
};

export const latencyBars = (histogram, translate) => {
  const totals = LATENCY_INTERVALS.map(() => 0);
  Object.entries(histogram).forEach(([start, count]) => {
    const index = LATENCY_INTERVALS.filter((intervalStart) => intervalStart <= Number(start)).length - 1;
    totals[index] += count;
  });
  return LATENCY_INTERVALS.map((start, index) => ({ key: String(start), label: intervalLabel(index, translate), value: totals[index] }));
};

// Corta a decima, nao arredonda: 59 950 a 59 999 nunca se leem "60,0 s" ao lado do "60 s ou mais".
export const formatLatency = (ms, language, translate) => {
  if (ms === null) return translate("analyticsNotAvailable");
  if (ms >= OPEN_STEP) return translate("analyticsSecondsOrMore", { value: seconds(OPEN_STEP) });
  return `${formatDecimal(Math.floor(ms / 100) / 10, language)} s`;
};

// Uma latencia varia em percentagem relativa e menos e melhor. Sem o anterior completo nao ha comparacao,
// nem quando um dos lados e "60 s ou mais": 60 000 e um limite inferior, e uma variacao calculada sobre ele
// nao e um numero ("+100,0%" de 30 000 para 60 000, quando pode ter sido muito mais).
export const latencyChange = ({ value, previous }, previousComplete, language) =>
  previousComplete && value < OPEN_STEP && previous < OPEN_STEP
    ? variation({ kind: "count", value, previous, better: "down" }, language)
    : NO_COMPARISON;
